export const DASHBOARD_REFRESH_EVENT = 'kcn:dashboard-refresh';
export const RENTAL_HISTORY_REFRESH_EVENT = 'kcn:rental-history-refresh';

/** Báo dashboard tải lại số liệu (sau tạo/sửa hợp đồng, thanh toán, ...) */
export function requestDashboardRefresh(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(DASHBOARD_REFRESH_EVENT));
}

/** Báo tab Lịch sử tải lại (hợp đồng + lịch sử thanh toán) */
export function requestRentalHistoryRefresh(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(RENTAL_HISTORY_REFRESH_EVENT));
}
